import type { CropVarietyConfigurationsByKey } from "../types.js";

export const pistachioVarietyConfigurations = {
    "pistachio.ahmad-aghaei": { crop: "pistachio", aliases: [], isExample: false, customName: false },
    "pistachio.akbari": { crop: "pistachio", aliases: [], isExample: false, customName: false },
    "pistachio.antep": { crop: "pistachio", aliases: [], isExample: false, customName: false },
    "pistachio.fandoghi": { crop: "pistachio", aliases: ["Owhadi", "Ohadi"], isExample: false, customName: false },
    "pistachio.golden-hills": { crop: "pistachio", aliases: [], isExample: false, customName: false },
    "pistachio.gumdrop": { crop: "pistachio", aliases: [], isExample: false, customName: false },
    "pistachio.joley": { crop: "pistachio", aliases: [], isExample: false, customName: false },
    "pistachio.kalleh-ghoochi": {
        crop: "pistachio",
        aliases: ["Kaleh Ghoochi", "Kalleghouchi"],
        isExample: false,
        customName: false,
    },
    "pistachio.kerman": { crop: "pistachio", aliases: [], isExample: true, customName: false },
    "pistachio.lost-hills": { crop: "pistachio", aliases: [], isExample: false, customName: false },
    "pistachio.peters": { crop: "pistachio", aliases: [], isExample: false, customName: false },
    "pistachio.randy": { crop: "pistachio", aliases: [], isExample: false, customName: false },
    "pistachio.red-aleppo": { crop: "pistachio", aliases: ["Aleppo"], isExample: false, customName: false },
    "pistachio.custom": { crop: "pistachio", aliases: [], isExample: false, customName: true },
} as const satisfies CropVarietyConfigurationsByKey;
